var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.598 4.708a2.75 2.75 0 0 1 1.944 1.956c.458 1.727.454 5.328.454 5.328s0 3.601-.458 5.328c-.252.951-.997 1.7-1.944 1.956-1.715.462-8.596.462-8.596.462s-6.88 0-8.596-.462a2.75 2.75 0 0 1-1.944-1.956C1 15.593 1 11.992 1 11.992s0-3.601.462-5.332c.252-.95.997-1.7 1.944-1.956 1.715-.462 8.596-.462 8.596-.462s6.877 0 8.596.466M9.75 8.72v6.543l5.751-3.272z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;